const config = {
    search_key: 'd6c39d0f9248852878f525ba20117dd2',
    search_id: '2e94cfd9',
    nutrition_key: 'f67dbde26f5a2dd7dab35d69024f2bde\t',
    nutrition_id: 'ffc56a2c',

};

module.exports = config;